import React, { useState, useEffect } from 'react';
import api from '../services/api';

const ContactPage = ({ onBack, user }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState(null); // 'loading', 'success', 'error'
  const [error, setError] = useState('');

  useEffect(() => {
    let currentUser = user;
    if (!currentUser) {
      try {
        const saved = localStorage.getItem('studymate_user');
        if (saved) {
          currentUser = JSON.parse(saved);
        }
      } catch (e) {
        console.error('Error parsing user data in ContactPage:', e);
      }
    }
    if (currentUser) {
      setFormData(prev => ({
        ...prev,
        name: currentUser.name || '',
        email: currentUser.email || ''
      }));
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setError('');

    try {
      await api.post('/contact', formData);
      setStatus('success');
      
      let currentUser = user;
      if (!currentUser) {
        try {
          const saved = localStorage.getItem('studymate_user');
          if (saved) currentUser = JSON.parse(saved);
        } catch (err) {}
      }
      
      setFormData({
        name: currentUser ? (currentUser.name || '') : '',
        email: currentUser ? (currentUser.email || '') : '',
        subject: '',
        message: ''
      });
    } catch (err) {
      console.error('Failed to send contact message:', err);
      setStatus('error');
      const rawError = err.response?.data?.error;
      const parsedError = typeof rawError === 'object'
        ? (rawError.message || rawError.code || JSON.stringify(rawError))
        : (rawError || 'Failed to send message. Please try again later.');
      setError(parsedError);
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-info-card">
        <div className="contact-info-header">
          <h2>Contact Us</h2>
          <p>Have questions or feedback? We'd love to hear from you. Our team is here to help.</p>
        </div>

        <div className="contact-details">
          <div className="contact-detail-item">
            <div className="contact-detail-icon">
              <i className="fas fa-envelope"></i>
            </div>
            <div className="contact-detail-content">
              <h4>Email</h4>
              <p>support@studycentro.com</p>
            </div>
          </div>
        </div>

        <div className="contact-socials">
          <a href="#" className="social-link" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
          <a href="#" className="social-link" aria-label="LinkedIn"><i className="fab fa-linkedin-in"></i></a>
          <a href="#" className="social-link" aria-label="GitHub"><i className="fab fa-github"></i></a>
          <a href="#" className="social-link" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
        </div>
      </div>

      <div className="contact-form-card">
        {status === 'success' ? (
          <div className="status-message" style={{ textAlign: 'center', padding: '40px' }}>
            <i className="fas fa-circle-check" style={{ fontSize: '3rem', marginBottom: '16px', display: 'block' }}></i>
            <h3>Message Sent!</h3>
            <p>Thank you for reaching out. We'll get back to you shortly.</p>
            <button
              type="button"
              className="secondary"
              style={{ marginTop: '24px' }}
              onClick={() => setStatus(null)}
            >
              Send another message
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="contact-form-header">
              <h3>Send a Message</h3>
              <p className="text-muted">Fill out the form below and we'll be in touch.</p>
            </div>

            {error && (
              <div className="error-message" style={{ background: '#fef2f2', border: '1px solid #fee2e2', color: '#b91c1c', padding: '12px 16px', borderRadius: '6px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem' }}>
                <i className="fas fa-exclamation-circle" />
                {error}
              </div>
            )}

            <div className="contact-form-grid">
              <div>
                <label htmlFor="name">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder=""
                  required
                  value={formData.name}
                  onChange={handleChange}
                  disabled={status === 'loading'}
                />
              </div>
              <div>
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder=""
                  required
                  value={formData.email}
                  onChange={handleChange}
                  disabled={status === 'loading'}
                />
              </div>
              <div className="contact-form-full">
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="How can we help?"
                  required
                  value={formData.subject}
                  onChange={handleChange}
                  disabled={status === 'loading'}
                />
              </div>
              <div className="contact-form-full">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Your message here..."
                  required
                  value={formData.message}
                  onChange={handleChange}
                  disabled={status === 'loading'}
                ></textarea>
              </div>
            </div>

            <button
              type="submit"
              className="contact-submit-btn"
              disabled={status === 'loading'}
            >
              {status === 'loading' ? (
                <><i className="fas fa-spinner fa-spin"></i> Sending...</>
              ) : (
                <><i className="fas fa-paper-plane"></i> Send Message</>
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactPage;
